import { FC } from 'react';

import { ImageTheme } from 'APP/components/ImageTheme/ImageTheme';

interface ILogoIconProps {
  className?: string;
}

export const LogoIcon: FC<ILogoIconProps> = ({ className }) => {
  return (
    <ImageTheme
      className={className}
      lightImageName={PROJECT_CONFIG.imageAssets.mainLogoLight}
      darkImageName={PROJECT_CONFIG.imageAssets.mainLogoDark}
    />
  );
};
